import * as React from 'react';
import { useIntl } from 'react-intl';

const useTimeZone = () => {
  const intl = useIntl();
  const timeZoneMap = React.useMemo(() => (
    [
      {
        value: 'Asia/Shanghai',
        label: intl.formatMessage({ defaultMessage: '中国标准时间' }),
        country: 'CN',
      },
      {
        value: 'America/New_York', //美国 东部时区
        label: intl.formatMessage({ defaultMessage: '美东时间' }),
        country: 'US',
      },
      {
        value: 'America/Chicago', //美国 中部时区
        label: intl.formatMessage({ defaultMessage: '美中时间' }),
        country: 'US',
      },
      {
        value: 'America/Denver', //美国 山地时区
        label: intl.formatMessage({ defaultMessage: '美山地时间' }),
        country: 'US',
      },
      {
        value: 'America/Los_Angeles', //美国 太平洋时区
        label: intl.formatMessage({ defaultMessage: '美西时间' }),
        country: 'US',
      },
      {
        value: 'America/Anchorage', //美国 阿拉斯加时区
        label: intl.formatMessage({ defaultMessage: '阿拉斯加时间' }),
        country: 'US',
      },
      {
        value: 'Pacific/Honolulu', //美国 夏威夷时区
        label: intl.formatMessage({ defaultMessage: '夏威夷时间' }),
        country: 'US',
      },
    ]
  ), [intl.locale]);
  return timeZoneMap;
};

export {
  useTimeZone,
};
